const i18n = {
  en: {
    tooltipText1: 'Drag to change, click to remove',
    tooltipText2: 'Drag to change',
  },
  it: {
    tooltipText1: 'Trascina per modificare, fai clic per rimuovere',
    tooltipText2: 'Trascina per modificare',
  },
  zh: {
    tooltipText1: '拖动即可更改，点击即可删除',
    tooltipText2: '拖动即可更改',
  },
  es: {
    tooltipText1: 'Arrastra para cambiar, haz clic para quitar',
    tooltipText2: 'Arrastra para cambiar',
  },
  de: {
    tooltipText1: 'Zum Ändern ziehen, zum Entfernen klicken',
    tooltipText2: 'Zum Ändern ziehen',
  },
  fr: {
    tooltipText1: 'Faites glisser pour modifier, cliquez pour supprimer',
    tooltipText2: 'Faites glisser pour modifier',
  },
  pt: {
    tooltipText1: 'Arraste para alterar, clique para remover',
    tooltipText2: 'Arraste para alterar',
  },
  uk: {
    tooltipText1: 'Перетягніть, щоб змінити, натисніть, щоб видалити',
    tooltipText2: 'Перетягніть, щоб змінити',
  },
  ru: {
    tooltipText1: 'Перетащите, чтобы изменить, нажмите, чтобы удалить',
    tooltipText2: 'Перетащите, чтобы изменить',
  },
};

export default i18n;
